import { ReactNode, useEffect, useState } from 'react';
import { fetchLiveRooms, type LiveRoom } from './api';
import OneliveShell from './OneliveShell';
import OneliveSidebar from './OneliveSidebar';
import OneliveSiteFooter from './OneliveSiteFooter';

interface OnelivePageLayoutProps {
  children: ReactNode;
  pageClassName?: string;
  mainClassName?: string;
  activeUuid?: string;
  sidebarRooms?: LiveRoom[];
  showInlineFooter?: boolean;
}

/** PC: 좌측 GNB + 상단 헤더(_user_base) / 모바일: 헤더 + 하단 네비 (CSS로 사이드바·푸터 숨김) */
export default function OnelivePageLayout({
  children,
  pageClassName,
  mainClassName,
  activeUuid,
  sidebarRooms,
  showInlineFooter = true,
}: OnelivePageLayoutProps) {
  const [rooms, setRooms] = useState<LiveRoom[]>(sidebarRooms ?? []);

  useEffect(() => {
    if (sidebarRooms) {
      setRooms(sidebarRooms);
      return;
    }

    let mounted = true;
    fetchLiveRooms(50).then((list) => {
      if (mounted) setRooms(list);
    });

    return () => {
      mounted = false;
    };
  }, [sidebarRooms]);

  const pageClass = ['onelive-page', pageClassName].filter(Boolean).join(' ');
  const mainClass = ['onelive-main', mainClassName].filter(Boolean).join(' ');

  return (
    <OneliveShell>
      <div className={pageClass}>
        <OneliveSidebar rooms={rooms} activeUuid={activeUuid} />
        <div className="onelive-page-column">
          <main className={mainClass}>{children}</main>
          {showInlineFooter ? <OneliveSiteFooter className="onelive-page-inline-footer" /> : null}
        </div>
      </div>
    </OneliveShell>
  );
}
